module.exports = __webpack_public_path__ + "static/media/backTop.ed9e2331.svg";